import React from "react";
import Typography from "@mui/material/Typography";

export default function DownloadCSVModalTopo(
  props: DownloadCSVModalTopoPropsTypes
) {
  return (
    <React.Fragment>
      <div className="containerTitle">
        <Typography
          variant="h5"
          fontFamily={"Co Headline Regular"}
          gutterBottom
          align="left"
          marginLeft="15px"
        >
          Exportar CSV de {props.name}
        </Typography>
      </div>
    </React.Fragment>
  );
}

interface DownloadCSVModalTopoPropsTypes {
  name: string;
}